module.exports = __webpack_public_path__ + "static/media/reservation.88172d30.svg";